import { useEffect } from 'react';

import { useNavigation } from '@react-navigation/native';

/**
 * Disables the swipe-to-dismiss gesture on the parent (outer modal) screen while `locked` is
 * true, re-enabling it on cleanup/when `locked` goes false. Assumes exactly one level of
 * nesting between the calling screen and the modal Screen registered on the root stack.
 */
export const useParentGestureLock = (locked: boolean) => {
    const navigation = useNavigation();

    useEffect(() => {
        if (!locked) {
            return;
        }
        navigation.getParent()?.setOptions({ gestureEnabled: false });
        return () => navigation.getParent()?.setOptions({ gestureEnabled: true });
    }, [locked, navigation]);
};
